"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const urls_1 = __importDefault(require("./urls"));
const context_formatter_1 = require("./context-formatter");
const formatFunc = (context) => (0, context_formatter_1.format)(urls_1.default, context);
module.exports = formatFunc;
